module.exports = __webpack_public_path__ + "img/elasticsearch.e5a3368a.png";